import { z } from 'zod'

/**
 * This browser's FCM token, kept from the moment a member turns push on until
 * they turn it off or log out. Its presence IS the opt-in: the shell
 * re-registers on load only when it is here and belongs to the member signed
 * in, so a second account on the same browser never inherits the first one's
 * pushes. Logout reads it to tell mm-be (`fcm_token`), then drops it.
 */
const KEY = 'mm-push-device'

const storedSchema = z.object({ token: z.string().min(1), userId: z.number() })

export type StoredDevice = z.infer<typeof storedSchema>

export const readDevice = (): StoredDevice | null => {
  try {
    const raw = window.localStorage.getItem(KEY)
    const parsed = storedSchema.safeParse(raw === null ? null : JSON.parse(raw))
    return parsed.success ? parsed.data : null
  } catch {
    return null
  }
}

export const writeDevice = (device: StoredDevice): void => {
  try {
    window.localStorage.setItem(KEY, JSON.stringify(device))
  } catch {
    // Blocked storage: push still works this visit, it just is not resumed on the next load.
  }
}

export const forgetDevice = (): void => {
  try {
    window.localStorage.removeItem(KEY)
  } catch {
    // Nothing kept, nothing to forget.
  }
}
